export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40180aee44a91101ae04536061553c6d98f814774a&name=revalidateCommunity!'